import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Accueil.css";

const Accueil = () => {
  const navigate = useNavigate();

  const images = [
    {
      src: "/images/iphone17promax.png",
      text: "Découvrez nos smartphones haut de gamme",
    },
    {
      src: "/images/airpods.png",
      text: "Profitez du meilleur son avec nos casques audio",
    },
    {
      src: "/images/applewatch11.png",
      text: "Repoussez les limites avec nos ordinateurs performants",
    },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setIndex((prev) => (prev + 1) % images.length),
      5000
    );
    return () => clearInterval(interval);
  }, [images.length]);

  // --- Fonction navigation vers Produits ---
 const goToShop = () => {
  navigate("/shop");
};


  return (
    <div className="accueil">

      {/* === SECTION HERO === */}
      <section className="hero">
        <img
          src={images[index].src}
          alt="Produit vedette"
          className="hero-image"
        />
        <div className="hero-overlay">
          <h1 className="hero-text">{images[index].text}</h1>
        </div>
      </section>

      {/* === MEILLEURES VENTES === */}
      <section className="ventes">
        <h2>⭐ Meilleures ventes</h2>
        <div className="ventes-grid">
          <div className="vente-card">
            <img src="/images/iphone17.png" alt="Produit 1" />
            <p>iPhone 17</p>
          </div>
          <div className="vente-card">
            <img src="/images/iphone17pro.png" alt="Produit 2" />
            <p>iPhone 17 Pro</p>
          </div>
          <div className="vente-card">
            <img src="/images/airpods.png" alt="Produit 3" />
            <p>Airpods</p>
          </div>
          <div className="vente-card">
            <img src="/images/applewatch11.png" alt="Produit 4" />
            <p>Apple Watch 11</p>
          </div>
        </div>
      </section>

      {/* === CATÉGORIES === */}
    <section className="categories">
  <h2>🛒 Nos Catégories de Services</h2>
  <div className="categories-grid">

    <button className="categorie-card" onClick={goToShop}>
      <i className="fa-solid fa-mobile-screen"></i>
      <p>Smartphones</p>
    </button>

    <button className="categorie-card" onClick={goToShop}>
      <i className="fa-solid fa-headphones"></i>
      <p>Casques</p>
    </button>

    <button className="categorie-card" onClick={goToShop}>
      <i className="fa-solid fa-laptop"></i>
      <p>Ordinateurs</p>
    </button>

    <button className="categorie-card" onClick={goToShop}>
      <i className="fa-solid fa-clock"></i>
      <p>Montres</p>
    </button>

    <button className="categorie-card" onClick={goToShop}>
      <i className="fa-solid fa-gamepad"></i>
      <p>Accessoires</p>
    </button>

    <button className="categorie-card" onClick={goToShop}>
      <i className="fa-solid fa-tv"></i>
      <p>TV & Écrans</p>
    </button>

  </div>
</section>


      {/* === TÉMOIGNAGES === */}
      <section className="temoignages">
        <h2>💬 Retours d’expérience</h2>
        <div className="temoignages-grid">
          <div className="temoignage-card">
            <p>"Super qualité et livraison rapide !"</p>
            <h4>Awa Diallo</h4>
          </div>
          <div className="temoignage-card">
            <p>"Excellent service client, je recommande."</p>
            <h4>Mamadou Saïdou</h4>
          </div>
          <div className="temoignage-card">
            <p>"Produit conforme et durable."</p>
            <h4>Hadi Diouf</h4>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Accueil;
